(function($) {
    
    const search = () => {
        const $page = $('body.page-template-page-candidate-search')
        const $collapse = $page.find('.filter-title-wrapper')
        const $results = $page.find('.results > .result')
        const $selectAll = $page.find('.btn-select-all')
        const $clear = $page.find('.btn-clear')
        const $fiterActions = $page.find('.filter-actions')
        const $officeTitleSearch = $page.find('#office-title-search')
        const $filterOptions = $page.find('.filter-options-input')
        const $candidateSearch = $page.find('#candidate-search')
        const $clearAllFilters = $page.find('.btn[data-clear="all"]')
        const $clearFilters = $page.find('.btn[data-clear-key][data-clear-value]')
        const $btnEndorse = $page.find('.btn[data-endorse]')
        const $btnNotify = $page.find('.btn[data-notify]')

        $collapse.on('click', function() {
            $(this).closest('.filter').toggleClass('collapsed')
        })

        $results.each(function() {
            $checkbox = $(this).find('button.checkbox')
            $checkbox.on('click', function() {
                $(this).toggleClass('selected')
            })
        })

        $selectAll.on('click', function() {
            $results.each(function() {
                $checkbox = $(this).find('button.checkbox')
                $checkbox.addClass('selected')
            })
        })

        $clear.on('click', function() {
            $results.each(function() {
                $checkbox = $(this).find('button.checkbox')
                $checkbox.removeClass('selected')
            })
        })

        $.each([$filterOptions], function() {
            $(this).on('input', function(e) {
                const $input = $(e.target);
                const { value } = e.target;
                const $options = $input.closest('.filter').find('input');
        
                $options.each(function() {
                    const val = $(this).val().toLowerCase();
                    const label_text = $(this).closest('label').text().toLowerCase();
        
                    //console.log('label_text: ' + label_text);
                    //console.log('val: ' + val);
        
                    // Check if value matches either the input value or label text
                    if (
                        !val.includes(value.toLowerCase()) &&
                        !label_text.includes(value.toLowerCase())
                    ) {
                        $(this).closest('label').addClass('hidden');
                    } else {
                        $(this).closest('label').removeClass('hidden');
                    }
                });
            });
        });
        

        $fiterActions.each(function() {
            const $buttons = $(this).find('.select-all, .clear-all')
            
            $buttons.on('click', function(e) {
                e.preventDefault()
                const $filter = $(this).closest('.filter')
                const $inputs = $filter.find('input[type="checkbox"]')
                
                $(this).hasClass('clear-all') 
                ? $inputs.each(function() {
                    $(this).prop('checked', false)
                })
                : $inputs.each(function() {
                    $(this).prop('checked', true)
                })
            })
        })

        $clearAllFilters.on('click', function() {
            const url = window.location.href.split('?')[0]
            window.location.href = url
        })

        $clearFilters.each(function() {
            $(this).on('click', function() {
                const key = $(this).data('clear-key')
                const value = $(this).data('clear-value')
                
                const url = new URL(window.location.href);
                const params = new URLSearchParams(url.search);

                const paramsArray = url.search.split('&')
                
                var urlString = ''
                paramsArray.map((param) => {
                    urlString += param.split('=')[1] === value.toString() ? '' : param + '&'
                })
                
                url.search = urlString
                window.location.href = url
            })
        })

        $btnEndorse.on('click', function() {
            const $this = $(this)
            const action = $this.data('endorse')
            const year = $this.data('year')
            const $results = $this.closest('.results-section').find('.results')
            ids = []
            $results.find('button.checkbox.selected').each(function() {
                $result = $(this).closest('.result')
                ids.push($result.data('endorsement-request-id'))
            })
            if (ids.length === 0) {
                return
            }
            fetch('/wp-json/endorsement-request/v1/bulk_update_requests', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': wpApiSettings.nonce
                },
                body: JSON.stringify({
                    action: action,
                    year: year,
                    ids: ids
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                if (data.success) {
                        data.results.map(x => {
                            const $result = $results.find('.result[data-endorsement-request-id="' + x.request_id + '"]')
                            const $status = $result.find('.status')
                            $result.find('button.checkbox').removeClass('selected')
                            if (action === 'approved') {
                                $status.removeClass('rejected').addClass('approved')
                                $status.html('<svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22 44.5C27.8348 44.5 33.4305 42.1822 37.5564 38.0564C41.6822 33.9305 44 28.3348 44 22.5C44 16.6652 41.6822 11.0695 37.5564 6.94365C33.4305 2.81785 27.8348 0.5 22 0.5C16.1652 0.5 10.5695 2.81785 6.44365 6.94365C2.31785 11.0695 0 16.6652 0 22.5C0 28.3348 2.31785 33.9305 6.44365 38.0564C10.5695 42.1822 16.1652 44.5 22 44.5ZM31.7109 18.4609L20.7109 29.4609C19.9031 30.2687 18.5969 30.2687 17.7977 29.4609L12.2977 23.9609C11.4898 23.1531 11.4898 21.8469 12.2977 21.0477C13.1055 20.2484 14.4117 20.2398 15.2109 21.0477L19.25 25.0867L28.7891 15.5391C29.5969 14.7312 30.9031 14.7312 31.7023 15.5391C32.5016 16.3469 32.5102 17.6531 31.7023 18.4523L31.7109 18.4609Z" fill="#036032"/></svg>Endorsed')
                            } else {
                                $status.removeClass('approved').addClass('rejected')
                                $status.html('<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 24C15.6826 24 18.7348 22.7357 20.9853 20.4853C23.2357 18.2348 24.5 15.1826 24.5 12C24.5 8.8174 23.2357 5.76516 20.9853 3.51472C18.7348 1.26428 15.6826 0 12.5 0C9.3174 0 6.26516 1.26428 4.01472 3.51472C1.76428 5.76516 0.5 8.8174 0.5 12C0.5 15.1826 1.76428 18.2348 4.01472 20.4853C6.26516 22.7357 9.3174 24 12.5 24ZM8.70312 8.20312C9.14375 7.7625 9.85625 7.7625 10.2922 8.20312L12.4953 10.4062L14.6984 8.20312C15.1391 7.7625 15.8516 7.7625 16.2875 8.20312C16.7234 8.64375 16.7281 9.35625 16.2875 9.79219L14.0844 11.9953L16.2875 14.1984C16.7281 14.6391 16.7281 15.3516 16.2875 15.7875C15.8469 16.2234 15.1344 16.2281 14.6984 15.7875L12.4953 13.5844L10.2922 15.7875C9.85156 16.2281 9.13906 16.2281 8.70312 15.7875C8.26719 15.3469 8.2625 14.6344 8.70312 14.1984L10.9062 11.9953L8.70312 9.79219C8.2625 9.35156 8.2625 8.63906 8.70312 8.20312Z" fill="#651816"/></svg>Not Endorsed')
                            }
                    })
                    const timeStamp = Date.now()
                    const $message = $page.find('#page-message')
                    $message.removeClass()
                    $message.addClass('mb-6 timestamp-'+timeStamp)
                    const candidate = data.results.length > 1 ? 'candidates' : 'candidate'
                    $message.html(`${data.results.length} ${candidate} successfully ${action === 'approved' ? 'endorsed' : 'not endorsed'}`)
                    setTimeout(() => {
                        $page.find('.timestamp-'+timeStamp).addClass('d-none') 
                    }, 5000)
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        })

        $btnNotify.on('click', function() {
            const $this = $(this)
            const $results = $this.closest('.results-section').find('.results')
            ids = []
            $results.find('button.checkbox.selected').each(function() {
                $result = $(this).closest('.result')
                ids.push($result.data('endorsement-request-id'))
            })
            if (ids.length === 0) {
                return
            }
            fetch('/wp-json/endorsement-request/v1/bulk_notify_candidates', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': wpApiSettings.nonce
                },
                body: JSON.stringify({
                    ids: ids,
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log(data)
                if (data.success) {
                    data.notifications.map(x => {
                        const $result = $results.find('.result[data-endorsement-request-id="' + x.request_id + '"]')
                        const $status = $result.find('.status')
                        $result.find('button.checkbox').removeClass('selected')
                    })
                    const timeStamp = Date.now()
                    const $message = $page.find('#page-message')
                    $message.removeClass()
                    $message.addClass('mb-6 timestamp-'+timeStamp)
                    const notification = data.notifications.length > 1 ? 'candidates' : 'candidate'
                    $message.html(`${data.notifications.length} ${notification} successfully notified`)
                    setTimeout(() => {
                        $page.find('.timestamp-'+timeStamp).addClass('d-none') 
                    }, 5000)
                }
            })
            .catch(error => {
                console.error('Error:', error);
            });
        })

        // CSV Export handler
        const $exportCsvBtn = $page.find('#export-csv-btn');
        $exportCsvBtn.on('click', function(e) {
            e.preventDefault();
            // Find the search form and serialize filters
            const $form = $page.find('form');
            const formData = $form.serializeArray();
            let filters = {};
            let sort = {};
            let year = '';
            formData.forEach(function(item) {
                // Handle sort and filter fields
                if (item.name.startsWith('sort[')) {
                    const key = item.name.match(/sort\[(.*?)\]/)[1];
                    sort[key] = item.value;
                } else if (item.name.startsWith('request[') || item.name.startsWith('candidate[')) {
                    const match = item.name.match(/(request|candidate)\[(.*?)\]/);
                    if (match) {
                        const group = match[1];
                        const key = match[2];
                        if (!filters[group]) filters[group] = {};
                        if (filters[group][key]) {
                            // If already set, convert to array
                            if (!Array.isArray(filters[group][key])) {
                                filters[group][key] = [filters[group][key]];
                            }
                            filters[group][key].push(item.value);
                        } else {
                            filters[group][key] = item.value;
                        }
                    }
                } else if (item.name === 'election_year') {
                    year = item.value;
                }
            });
            // Fallback to global election_year if not in form
            if (!year) {
                // Try to get from window.election_year first
                if (window.election_year) {
                    year = window.election_year;
                } else {
                    // Fallback to current year
                    year = new Date().getFullYear().toString();
                }
            }
            
            const requestData = {
                year: year,
                filters: filters,
                sort: sort
            };
            
            if (window.affiliate_id) {
                requestData.affiliate_id = window.affiliate_id;
            }
            
            // Use POST request instead of GET
            fetch('/wp-json/endorsement-request/v1/export_csv', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': wpApiSettings.nonce
                },
                body: JSON.stringify(requestData)
            })
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'endorsement_requests.csv';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });

        const $exportPdfBtn = $page.find('#export-pdf-btn');
        $exportPdfBtn.on('click', function(e) {
            e.preventDefault();
            const $form = $page.find('form');
            const formData = $form.serializeArray();
            let filters = {};
            let sort = {};
            let year = '';
            formData.forEach(function(item) {
                if (item.name.startsWith('sort[')) {
                    const key = item.name.match(/sort\[(.*?)\]/)[1];
                    sort[key] = item.value;
                } else if (item.name.startsWith('request[') || item.name.startsWith('candidate[')) {
                    const match = item.name.match(/(request|candidate)\[(.*?)\]/);
                    if (match) {
                        const group = match[1];
                        const key = match[2];
                        if (!filters[group]) filters[group] = {};
                        if (filters[group][key]) {
                            if (!Array.isArray(filters[group][key])) {
                                filters[group][key] = [filters[group][key]];
                            }
                            filters[group][key].push(item.value);
                        } else {
                            filters[group][key] = item.value;
                        }
                    }
                } else if (item.name === 'election_year') {
                    year = item.value;
                }
            });
            if (!year) {
                if (window.election_year) {
                    year = window.election_year;
                } else {
                    year = new Date().getFullYear().toString();
                }
            }
            
            const requestData = {
                year: year,
                filters: filters,
                sort: sort
            };
            
            if (window.affiliate_id) {
                requestData.affiliate_id = window.affiliate_id;
            }
            
            // Use POST request instead of GET
            fetch('/wp-json/endorsement-request/v1/export_pdf', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': wpApiSettings.nonce
                },
                body: JSON.stringify(requestData)
            })
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'endorsement_requests.pdf';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            })
            .catch(error => {
                console.error('Error:', error);
            });
        });

    }
    
    $(function() {
        search()
    })
})(jQuery);
